import GradientBorder from './gradient-border';

export default GradientBorder;
